import MainLayout from '@/components/layout/MainLayout.vue';

export default {
  name: "agreementSchool",

  components: {
    MainLayout
  },

  data() {
    return {
      seen: false
    }
  },

  methods: {
    submit() {
      this.$router.push({
        name: "signupSchool"
      });
    },
  },

  mounted() {

  },

  computed: {
    isDisabled: function () {
      return !this.seen;
    }
  }
};
